const time = {
  "formats": {
    "default": "%m/%d/%Y %I:%M %p %Z",
    "short": "%d %b %H:%M",
    "long": "%B %d, %Y %H:%M",
    "graph": "%a %b %d, %Y %I:%M %p",
    "event_datetime": "%a %B %d, %Y %I:%M %p %Z",
    "time": "%l:%M %p",
    "time_only": "%H:%M",
    "meridian": "%p",
    "hour_meridian": "%-H:00",
    "short_date": "%m/%d/%Y",
    "admin_date": "%Y/%m/%d",
    "admin_time": "%H:%M:%S %z (%Z)",
    "admin_local": "%Y/%m/%d %H:%M:%S",
    "admin_datetime": "%Y/%m/%d %H:%M:%S %z (%Z)",
    "admin_compact": "%m/%d/%y %H:%M %Z",
    "long_month_and_year": "%B %Y",
    "month_and_year": "%Y-%m",
    "js": {
      "time": "%-I:%M %p",
      "time_only": "%-I:%M",
      "hour_only": "%-I %p",
      "hour_minutes": "%-I:%M %p"
    }
  },
  "am": "AM",
  "pm": "PM",
  "day": {
    "one": "1 day",
    "other": "%{count} days"
  },
  "hour": {
    "one": "1 hour",
    "other": "%{count} hours"
  },
  "min": {
    "one": "1 minute",
    "other": "%{count} minutes"
  },
  "second": {
    "one": "1 second",
    "other": "%{count} seconds"
  }
}

module.exports = time